// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext.js';
import LoginPage from './pages/LoginPage.js';
import Dashboard from './pages/Dashboard.js';
import PrivateRoute from './components/PrivateRoute.js';
import Layout from './components/layout/layout.js';
import StoreManagementPage from './pages/Admin/StoreManagementPage.js';
import UserManagementPage from './pages/Admin/UserManagementPage.js';
import ProductManagementPage from './pages/Admin/ProductManagementPage.js';
import PurchasesPage from './pages/PurchasesPage.js';
import InventoryManagementPage from './pages/InventoryManagementPage.js';
import PosPage from './pages/PosPage.js';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import NewPurchasePage from './pages/NewPurchasePage.js'; // <-- IMPORTAR
import TransfersPage from './pages/TransfersPage.js';
import NewTransferPage from './pages/NewTransferPage.js'; // <-- IMPORTAR
import CustomerManagementPage from './pages/Admin/CustomerManagementPage.js';
import ReportsPage from './pages/ReportsPage.js'; 
import WastagePage from './pages/WastagePage.js';
import PromotionManagementPage from './pages/Admin/PromotionManagementPage.js';
import CategoryManagementPage from './pages/Admin/CategoryManagementPage.js';
import { LayoutProvider } from './context/LayoutContext.js';
import SupplierManagementPage from './pages/Admin/SupplierManagementPage.js';
import BrandManagementPage from  './pages/Admin/BrandManagementPage.js'
import ReceiptPage from './pages/ReceiptPage.js';
import ExpensesPage from './pages/ExpensesPage.js';
const theme = createTheme({
    // ... tu tema
});

function App() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Router>
     
     
     
                {/* AuthProvider envuelve a TODAS las rutas */}
                <AuthProvider> 

                 <LayoutProvider>
                    <Routes>
                        {/* Ruta pública */}
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/receipt/:uuid" element={<ReceiptPage />} />
                        {/* Rutas Protegidas */}
                        <Route element={<PrivateRoute />}>
                            <Route element={<Layout />}>
                                <Route path="/dashboard" element={<Dashboard />} />
                                <Route path="/admin/stores" element={<StoreManagementPage />} />
                                <Route path="/admin/users" element={<UserManagementPage />} />
                                 <Route path="/admin/products" element={<ProductManagementPage />} />
                                 <Route path="/inventory" element={<InventoryManagementPage />} />
                                <Route path="/pos" element={<PosPage />} />
                                <Route path="/purchases" element={<PurchasesPage />} /> 
                                <Route path="/purchases/new" element={<NewPurchasePage />} />
                                <Route path="/transfers" element={<TransfersPage />} /> {/* <-- AÑADIR RUTA */}
                                <Route path="/transfers/new" element={<NewTransferPage />} />
                                <Route path="/admin/customers" element={<CustomerManagementPage />} /> 
                                <Route path="/reports" element={<ReportsPage />} />
                                <Route path="/wastage" element={<WastagePage />} />
                                <Route path="/admin/promotions" element={<PromotionManagementPage />} />
                                <Route path="/admin/customers" element={<CustomerManagementPage />} />
                                <Route path="/admin/categories" element={<CategoryManagementPage />} />
                                <Route path="/admin/categories" element={<CategoryManagementPage />} />
                                <Route path="/admin/suppliers" element={<SupplierManagementPage />} /> 
                                <Route path="/admin/brands" element={<BrandManagementPage />} />
                                <Route path="/admin/expenses" element={<ExpensesPage />} />
                                {/* AÑADIREMOS MÁS RUTAS AQUÍ */}
                                
                                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                            </Route>
                        </Route>

                    </Routes>
                    </LayoutProvider>
                </AuthProvider>
            </Router>
        </ThemeProvider>
    );
}

export default App;